import React from 'react';
import {List, useTheme} from '@material-ui/core';
import {NavLink} from 'react-router-dom';

import IntlMessages from "../../util/IntlMessages";

const NavMenuItem = props => {
  const {name, namePlainTxt, icon, link, badge} = props;
  const theme = useTheme();

  return (
    <List component="div" className='nav-menu-item'>
      <NavLink
        className="prepend-icon nav-menu-link"
        to={link}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span className="nav-text" style={{ display: 'flex', alignItems: 'center' }}>
          {!!icon && (
            <i className={'zmdi zmdi-hc-fw  zmdi-' + icon}/>
          )}
          {namePlainTxt ? name : (
            <IntlMessages id={ name }/>
          )}
        </span>
        {!!badge && (
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 20,
              height: 20,
              borderRadius: 10,
              padding: '0 6px',
              fontSize: 11,
              fontWeight: 600,
              lineHeight: 1,
              backgroundColor: theme.palette.primary.main,
              color: '#fff',
            }}
          >
            {badge}
          </span>
        )}
      </NavLink>
    </List>
  )
};

export default NavMenuItem;
